<template>
  <div class="store-skeleton">
    <SkeletonAnimation>
      <div class="banner"></div>
      <div class="store-info">
        <div class="store-info_flex_12"></div>
        <div class="store-info_flex_62"></div>
        <div class="store-info__sku">
          <div v-for="item in 3" :key="item" class="store-info__sku_item"></div>
        </div>
      </div>
      <div class="store-content">
        <div class="store-content__infos">
          <div v-for="item in 3" :key="item" class="store-item">
            <div class="store-item_left">
              <div class="block1"></div>
              <div class="block2"></div>
            </div>
            <div class="store-item_right">
              <div class="block3"></div>
            </div>
          </div>
        </div>
      </div>
    </SkeletonAnimation>
  </div>
</template>
<script>
import SkeletonAnimation from '../../SkeletonAnimation';
export default {
  name: 'StoreSkelectH5',
  components: {
    SkeletonAnimation,
  },
};
</script>
<style lang="scss" scoped>
.store-skeleton {
  background: #F5F5F7;
}
.banner{
height: rem(370);
background: #F0F0F3;
margin-bottom: rem(70);
}
.store-info_flex_12{
  width: rem(300);
height: rem(40);
background: #E5E5E8;
border-radius: rem(8);
margin:0 auto ;
margin-bottom: rem(25);
}
 .store-info_flex_62{
   width: rem(600);
height: rem(30);
background: #E5E5E8;
border-radius: rem(8);
margin:0 auto ;
margin-bottom: rem(124);
 }
 .store-info__sku{
   padding: 0 rem(55);
   display: flex;
   justify-content: space-between;
   margin-bottom: rem(55);
   
 }
 .store-info__sku_item{
   width: rem(180);
height: rem(28);
background: #E5E5E8;
border-radius: rem(8);
 }
 .store-item{
   display: flex;
   justify-content: space-between;
   height: rem(272);
background: #F9F9FA;
border-radius: rem(12);
margin: 0 rem(24) rem(20);
padding: rem(22) rem(18);
 }
 .block1 {
width: rem(289);
height: rem(40);
background: #E8E8EA;
border-radius: rem(8);
margin-bottom: rem(20);
 }
 .block2{
width: rem(439);
height: rem(28);
background: #E8E8EA;
border-radius: rem(8);
 }
 .block3 {
   width: rem(174);
height: rem(174);
background: #E5E5E8;
border-radius: rem(8);
 }
</style>
